import { callOutState } from "../models/callOutState";
import { callbacksToDial } from "../models/callbacksToDial";
import { callReceived } from "../models/callReceived";
import { dispositionsReceived } from "../models/dispositionList";
import { outboundCamp } from "../models/outboundCamp";
import { subDispositionReceived } from "../models/subDispositions";
import { unavailablesHistory } from "../models/unavailablesHistory";
import { unavailablesHistoryDetail } from "../models/unavailablesHistoryDetail";
import { unavailablesReceived } from "../models/unavailablesList";
import { callsTodayHistory } from "../models/callsTodayHistory";
import { chatToAdminList } from "../models/chatToAdminList";
import { agentTransfer, inboundCampTransfer, numberTransfer } from "../models/optionsTransfers";
import { ivrList } from "../models/ivrList";

export const outboundCampToModel = (outboundCampJson) =>{
    return new outboundCamp(outboundCampJson);
}
export const callReceivedToModel = (callReceivedJson) =>{
    return new callReceived(callReceivedJson);
}
export const unavailablesModel = (unavailablesObj) =>{
    let unavailablesList = [];
    unavailablesList = Object.values(unavailablesObj).map(unavailable => new unavailablesReceived(unavailable));
    return unavailablesList;
}
export const dispositionsModel = (dispositionsObj) =>{
    let dispositionsList = [];
    dispositionsList = Object.values(dispositionsObj).map(disposition => new dispositionsReceived(disposition));
    return dispositionsList;
}
export const subDispositionsModel = (subdispositionsObj) =>{
    let subdispositionsList = [];
    subdispositionsList = Object.values(subdispositionsObj).map(subdisposition => new subDispositionReceived(subdisposition));
    return subdispositionsList;
}
export const unavailablesHistoryModel = (historyObj) =>{
    let historyList = [];
    historyList = Object.values(historyObj).map(history => new unavailablesHistory(history));
    return historyList;
}
export const detailsUnavailablesHistoryModel = (detailsHistoryObj) =>{
    let detailsHistoryList = [];
    detailsHistoryList = Object.values(detailsHistoryObj).map(history => new unavailablesHistoryDetail(history));
    return detailsHistoryList;
}
export const callbacksToDialModel = (callbacksObj) =>{
    let callbacksList = [];
    callbacksList = Object.values(callbacksObj).map(callbackToDial => new callbacksToDial(callbackToDial));
    return callbacksList;
}
export const callOutStateToModel = (callOutInfoJson) =>{
    return new callOutState(callOutInfoJson);
}
export const callsTodayModel = (callsTodayObj) =>{
    let callsTodayList = [];
    callsTodayList = Object.values(callsTodayObj).map(callRegistry => new callsTodayHistory(callRegistry));
    return callsTodayList;
}
export const chatToAdminModel = (chatToAdminObj) =>{
    let chatToAdmins = [];
    chatToAdmins = Object.values(chatToAdminObj).map(chatAdminList => new chatToAdminList(chatAdminList));
    return chatToAdmins;
}
export const inboundCampTransferToModel = (inboundCampJson) =>{
    return new inboundCampTransfer(inboundCampJson);
}
export const agentTransferToModel = (agentJson) =>{
    return new agentTransfer(agentJson);
}
export const numberTransferToModel = (numberJson) =>{
    return new numberTransfer(numberJson);
}
export const ivrListModel = (ivrObj) =>{
    let ivrArray = [];
    ivrArray = Object.values(ivrObj).map(ivrElement => new ivrList(ivrElement));
    return ivrArray;
}
